import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isRouteLoading: false
};

const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    setRouteLoading: (state, action) => {
      state.isRouteLoading = action.payload;
    }
  }
});

export const { setRouteLoading } = loadingSlice.actions;
export const loadingReducer = loadingSlice.reducer;
